import { render } from "./signature.vue?vue&type=template&id=1a37f9f9"
import script from "./signature.vue?vue&type=script&lang=js"
export * from "./signature.vue?vue&type=script&lang=js"

import "./signature.vue?vue&type=style&index=0&id=1a37f9f9&lang=css"
script.render = render

export default script